import React from 'react';

export const UnattachedIcon = (): React.ReactElement => (
  <svg width="24.000000" height="24.000000" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="clip1123_5768">
        <rect id="segmented-nav" width="24.000000" height="24.000000" fill="white" fillOpacity="0" />
      </clipPath>
    </defs>
    <rect id="segmented-nav" width="24.000000" height="24.000000" fill="#FFFFFF" fillOpacity="0" />
    <g clipPath="url(#clip1123_5768)">
      <path
        id="Vector"
        d="M21 7.5L9 7.5L9 13.5L21 13.5C21.39 13.5 21.77 13.34 22.06 13.06C22.34 12.77 22.5 12.39 22.5 12L22.5 9C22.5 8.6 22.34 8.22 22.06 7.93C21.77 7.65 21.39 7.5 21 7.5ZM3 6C2.2 6 1.44 6.31 0.87 6.87C0.31 7.44 0 8.2 0 9L0 12C0 12.79 0.31 13.55 0.87 14.12C1.44 14.68 2.2 15 3 15L21 15C21.79 15 22.55 14.68 23.12 14.12C23.68 13.55 24 12.79 24 12L24 9C24 8.2 23.68 7.44 23.12 6.87C22.55 6.31 21.79 6 21 6L3 6Z"
        fill="#3D5A80"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <path
        id="Vector"
        d="M15 13.5L15 7.5L16.5 7.5L16.5 13.5L15 13.5Z"
        fill="#3D5A80"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
